  <div class="dialog-content-wrapper" style="display: flex; min-height:400px">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">{{title}}</span>
          <button mat-icon-button class="mat-icon-button"
                  (click)="dialogRef.close()"
                  aria-label="Close dialog">
              <mat-icon class="white-fg">close</mat-icon>
          </button>
      </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0 form-wrapper">
    <div fxFlex fxLayout="column" fxLayoutAlign="center space-between">
        <span *ngIf = "message" class="message">{{message}}</span>
        <form [formGroup]="form" class="addDialog mt-16" fxLayout="column" fxFlex [ngStyle]="{'min-height.px': ((this.showDate2) ? 120 : 60)}">
            <div id='divDate1' fxFlex class="m-8">
                <app-intec-date-picker id='datePicker1' [placeholder]='this.date1Label' formControlName="date1" [max]='this.maxDate' [min]='this.minDate' class="form-control" required [setFocus]="true">
                </app-intec-date-picker>
                <validation-errors [control]="form.get('date1')" [min]='this.minDate' [max]='this.maxDate'></validation-errors>
            </div>
            <div *ngIf="this.showDate2" id='divDate2' fxFlex class="m-8">
                <app-intec-date-picker id='datePicker2' [placeholder]='this.date2Label' formControlName="date2" [max]='this.maxDate' [min]='this.minDate' class="form-control" required>
                </app-intec-date-picker>
                <validation-errors [control]="form.get('date2')" [min]='this.minDate' [max]='this.maxDate'></validation-errors>
            </div>
            <mat-error *ngIf="form.errors?.minmaxerror" class="validation-error-msg">The {{date1Label}} value cannot be greater than the {{date2Label}} value.</mat-error>
        </form>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button mat-raised-button
                    type="submit" 
                    [disabled]="(!form.valid) || (form.pristine)"
                    [mat-dialog-close]="1" 
                    (click)="confirmSubmit()"
                    class="save-button mat-accent"
                    style="padding-left: 8px; min-width:100px !important;"
                    aria-label="OK">
                OK
            </button>
        </div>
    </div>
</div>
